<div class="layout-rightpanel" *ngIf="this.service.openPanelSync"
    [ngClass]="{'layout-rightpanel-active': this.service.openPanelSync}"
    (click)="layoutService.currentLayout$.value.onRightPanelClick()">
    <p-scrollPanel #scrollRightPanel [style]="{height: '100%'}">

        <ng-container [appLazy]="this.service.customViewSync"></ng-container>

    </p-scrollPanel>
</div>
